import { ReactNode } from 'react';
import TwoSidebar from '../organisms/TwoSidebar';
import { ToastContainer } from 'react-toastify';

interface LayoutProps {
    children: ReactNode;
}

const Layout = ({ children }: LayoutProps) => {
    return (
        <div className="flex">
            <div className='bg-red-500'></div>
            <div className='bg-green-500'></div>
            <div className='bg-blue-500'></div>
            <div className='bg-gray-800'></div>
            <TwoSidebar />
            <ToastContainer
                stacked={true}
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme='colored'
            />
            <div style={{ width: "100%" }}>
                {children}
            </div>
        </div>
    );
};

export default Layout;